import React from 'react';
import DownloadTemplateSchedule from './DownloadTemplateSchedule';
import { Card } from 'antd';
import UploadSchedule from './UploadSchedule';
import ResetDeviceId from './ResetDeviceId';

const AttendanceSetting: React.FC = () => {
  return (
    <>
    <div style={{display: "flex", flex:1, marginTop: 30, gap:20} }>
      <Card title="Template Schedule" bordered={false}> 
        <DownloadTemplateSchedule/>
      </Card>
      <Card title="Upload Schedule" bordered={false}> 
        <UploadSchedule/>
      </Card>
      <Card title="Reset Device ID" bordered={false}> 
        <ResetDeviceId/>
      </Card>
    </div>
    
    </>
  );
};

export default AttendanceSetting;
